import { useBoundStore } from '@Store/useBoundStore';
import { useMutation } from '@tanstack/react-query';
import { HttpService } from '@Services/index';

const consentsData = [{ name: 'general', type: 'AUTHORIZED_VIEWER_TERM', version: '1.0' }];

export const useAuthorizedUserConsent = () =>
  useMutation({
    mutationFn: async (token: string) => {
      const { customerId, authorizedUserId } = useBoundStore.getState().onboardingSlice;
      const consentFormData = useBoundStore.getState().getConsentFormData();
      const imageBlob = await fetch(consentFormData as string).then((res) => res.blob());
      const formData = new FormData();
      formData.append(
        'consents',
        new Blob([JSON.stringify(consentsData)], { type: 'application/json' })
      );
      formData.append('image', imageBlob);

      await HttpService.post(
        `v1/user/${customerId}/authorized/user/${authorizedUserId}/terms_and_conditions/consent`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    },
  });
